<template>
  <div class="apply-success-wrapper">
    <h3 class="title">
      <img class="success" :src="require('@/assets/img/icon_success.png')" alt="" />
      <span>提交成功</span>
    </h3>
    <p class="desc">照片处方已提交，请等待药师审核</p>
    <div class="btn-box">
      <el-button size="medium" type="primary" style="width:98px" @click="onBack">返回</el-button>
      <el-button size="medium" type="primary" plain @click="onContinue">继续上传</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'applySuccess',
  data() {
    return {};
  },
  methods: {
    onBack() {
      this.$router.replace('/chooseConsultType');
    },
    onContinue() {
      this.$emit('onContinue');
    }
  }
};
</script>
<style lang="scss" scoped>
.apply-success-wrapper {
  padding-top: 72px;
  text-align: center;
  font-size: 14px;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: #242424;
    .success {
      margin-right: 16px;
      width: 24px;
      height: 24px;
    }
  }
  .desc {
    margin: 16px 0 61px 0;
    color: #707070;
  }
}
</style>
